// Import Vue y Router
import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';
import '../style.css';

// /src/plugins/vue-gtag.js
import VueGtag from 'vue-gtag';

// Vue router
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Siempre volver al tope de la página al cambiar de ruta
    return { top: 0 }
  }
});

// Vue app
const app = createApp(App);
app.use(router);
app.use(VueGtag, {
  config: { id: 'G-H3MC052Y9J' }
}, router);
app.mount('#app');